import React from "react";
import GoogleIcon from "@mui/icons-material/Google";

const GoogleReviewsButton = () => (
  <a
    className="floating-social-link floating-social-link--google"
    href="https://tiny.cc/aol-map"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Read or leave a Google review"
    title="Google Reviews"
    style={{
      border: "1px solid #e0e5e8",
      backgroundColor: "#fff",
      color: "#4285F4",
    }}
  >
    <GoogleIcon style={{ fontSize: 35 }} />
  </a>
);

export default GoogleReviewsButton;
